var exports = {
  "kL": "AppSkeleton.module__container___OEVDdn",
  "ER": "AppSkeleton.module__containerExiting___OEVDdn",
  "A1": "AppSkeleton.module__containerGuilds___OEVDdn",
  "BG": "AppSkeleton.module__containerRailless___OEVDdn",
  "w_": "AppSkeleton.module__containerReserveUserArea___OEVDdn",
  "u5": "AppSkeleton.module__containerReserveMobileBottomNav___OEVDdn",
  "aF": "AppSkeleton.module__outlineFrame___OEVDdn",
  "Qs": "AppSkeleton.module__content___OEVDdn",
  "iW": "AppSkeleton.module__main___OEVDdn",
  "NK": "AppSkeleton.module__mainSidebarless___OEVDdn",
  "qy": "AppSkeleton.module__contentColumn___OEVDdn",
};

module.exports = exports;
